import { jsx } from 'react/jsx-runtime';
import { useContext, useCallback, useMemo } from 'react';
import { Input } from '../../Input/Input.es.js';
import { TableFiltersContext } from '../Context/TableFilters.Context.es.js';
import { useFilterSize } from '../TableFilters.Filter.es.js';

const FilterInput = ({ start, size, name, icon, alignIcon, onChange, self, ...props })=>{
    const classes = useFilterSize({
        start,
        size
    });
    const { filters, setFilter } = useContext(TableFiltersContext);
    const handleChange = useCallback((event)=>{
        setFilter(name, event.target.value, self);
        onChange?.(event);
    }, [
        name,
        onChange,
        self,
        setFilter
    ]);
    const value = useMemo(()=>{
        return name in filters && typeof filters[name] !== 'object' ? String(filters[name]) : '';
    }, [
        name,
        filters
    ]);
    return jsx(Input, {
        ...props,
        className: classes,
        "data-testid": `table-filter-input-${name}`,
        value: value,
        emphasize: true,
        children: jsx(Input.Field.Text, {
            onChange: handleChange,
            value: value,
            children: icon && jsx(Input.Inline.Icon, {
                align: alignIcon,
                name: icon
            })
        })
    });
};
FilterInput.displayName = 'TableCard.Filters.Input';

export { FilterInput };
//# sourceMappingURL=Input.es.js.map
